import React from 'react';
import { H6 } from '@finect/tabular-core/Headings';
import { ChevronRight } from '@finect/tabular-icons/chevronRight';
import { stripHtmlTags } from '@finect/front-utils/html';
import { Excerpt, Inner, IconBlock } from './partials';
export var ArticleListItem = function ArticleListItem(_ref) {
  var article = _ref.article,
    onAction = _ref.onAction;
  var excerpt = stripHtmlTags(article.body.text).substring(0, 120);
  var handleClick = function handleClick() {
    onAction(article);
  };
  return React.createElement(Inner, {
    onClick: handleClick
  }, React.createElement("div", null, React.createElement(H6, null, article.title), React.createElement(Excerpt, null, excerpt)), React.createElement(IconBlock, null, React.createElement(ChevronRight, null)));
};